module.exports = "#error {\n  margin-top: 2em; }\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/posts/createpost.component.scss
// module id = 348
// module chunks = 1